(function () {
  if (window.__AG_PB_PD_BULLETS_INIT__) return;
  window.__AG_PB_PD_BULLETS_INIT__ = true;

  function qsa(sel, root) {
    return Array.prototype.slice.call((root || document).querySelectorAll(sel));
  }

  // ?type=otp — one-time-purchase-only landing pages. The shared bullets are
  // freeform richtext (no structural hook), so this hides list items whose
  // copy references subscription cancellation/pausing rather than the purchase itself.
  function isOtpMode() {
    try {
      return new URLSearchParams(location.search).get('type') === 'otp';
    } catch (e) {
      return false;
    }
  }

  function hideSubscriptionBullets(root) {
    qsa('.ag-pb-pd__bullets-shared li, .ag-pb-pd__bullets-shared p', root).forEach(function (el) {
      var text = (el.textContent || '').toLowerCase();
      var mentionsSkipOrPause = text.indexOf('skip') !== -1 || text.indexOf('pause') !== -1;
      var mentionsCancelOrSubscription = text.indexOf('cancel') !== -1 || text.indexOf('subscription') !== -1;
      if (mentionsSkipOrPause && mentionsCancelOrSubscription) {
        el.hidden = true;
      }
    });
  }

  function syncShipLine(root, optionIndex) {
    if (optionIndex < 1) return;

    qsa('[data-ag-pb-pd-bullets]', root).forEach(function (block) {
      if (!block.hasAttribute('data-ag-pb-pd-ship-1')
        && !block.hasAttribute('data-ag-pb-pd-ship-2')
        && !block.hasAttribute('data-ag-pb-pd-ship-3')) {
        return;
      }

      var row = block.querySelector('[data-ag-pb-pd-ship-list]');
      var textEl = block.querySelector('[data-ag-pb-pd-ship-text]');
      var list = row ? row.closest('.ag-pb-pd__bullets-list') : null;
      if (!row || !textEl) return;

      var text = (block.getAttribute('data-ag-pb-pd-ship-' + optionIndex) || '').trim();
      var empty = text === '';
      textEl.textContent = text;
      row.hidden = empty;
      if (list) list.hidden = empty;
    });
  }

  document.addEventListener('ag-pb-pd:variant-change', function (event) {
    var detail = event.detail || {};
    var optionIndex = parseInt(detail.optionIndex, 10);
    if (isNaN(optionIndex) || optionIndex < 1) return;

    var scope = detail.root || document;
    syncShipLine(scope, optionIndex);
  });

  function initOtp() {
    if (!isOtpMode()) return;
    hideSubscriptionBullets(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initOtp);
  } else {
    initOtp();
  }

  document.addEventListener('shopify:section:load', function (e) {
    if (isOtpMode()) hideSubscriptionBullets(e.target);
  });
})();
